import { getEnv } from '@luna/env';

import type { AddressSelectionItem, AddressSuggestion } from './AddressSearchTypes';

const MAXIMUM_SUGGESTIONS_NUMBER = 100;
const MINIMUM_SEARCH_CHARS = 3;

export const isValidSearchQuery = (query: string): boolean => query.length >= MINIMUM_SEARCH_CHARS;

export const getPlacesAutocompleteUrl = (query: string): string =>
    `${getEnv().autoCompleteServiceUrl}?q=${query}&size=${MAXIMUM_SUGGESTIONS_NUMBER}`;

export const transformAddressesToAddressSelectionItems = (
    addressSuggestions: AddressSuggestion[],
): AddressSelectionItem[] =>
    addressSuggestions.map((suggestion) => ({
        label: suggestion.autocompleteString,
        value: suggestion.autocompleteString,
        address: suggestion.address,
    }));
